const milestones = [5, 10, 30, 50, 100];

export const getMilestone = (rank: number) => {
    if (rank <= 3) {
        return null;
    }

    for (const milestone of milestones) {
        if (rank <= milestone) {
            return milestone;
        }
    }

    return null;
};
